import TemplateView from "../../TemplateView"
import messageResource from "../../messageResource"
import NameInput from "../NameInput"
import {ProjectPanelTabs} from "./ProjectPanel"
import {atImgPath} from "../../atBrowserUtils"
import EditActionButton from '../../controls/task/EditActionButton'
import {EntityTextLimits} from 'constants'

export default class ProjectPanelHeader extends TemplateView {
    constructor($containerEl, $panel) {
        super($containerEl);
        this.$panel = $panel;

        this.state = {
            projectName: '',
            customerName: '',
            readOnly: false,
            blockedDueToLockedTime: false,
            blockedDueToUnavailableToModifyTimeTrack: false,
            canManageAllUsersWithoutAutoApproved: false,
        };

        this.onStateChanged(() => this.updateView());
    }

    templateHtml() {
        return "<div class='editProjectPanelHeader'>" +
               "  <div class='cpInfo'>" +
               "    <span class='customerName ellipsis'/><img src='<%=separatorArrow%>' class='separator'/>" +
               "  </div>" +
               "  <div class='projectNamePlaceholder'/>" +
               "  <div class='actions'></div>" +
               "  <div class='tabs'>" +
               "    <div class='details'><span class='tabText'><%=detailsTab%></span></div>" +
               "    <div class='assignedUsers'><span class='tabText'><%=assignedUsersTab%></span></div>" +
               "    <div class='managers'><span class='tabText'><%=managersTab%></span></div>" +
               "    <div class='budgets'><span class='tabText'><%=budgetsTab%></span></div>" +
               "  </div>" +
               "</div>";
    }

    shouldUpdateOnInit() {
        return false;
    }

    messageKeys() {
        return {
            detailsTab: "project.edit_panel.tabs.details",
            assignedUsersTab: 'project.edit_panel.tabs.assigned_users',
            managersTab: 'project.edit_panel.tabs.managers',
            budgetsTab: 'project.edit_panel.tabs.budgets'
        }
    }

    templateModel() {
        return {
            separatorArrow: atImgPath('taskManagement/arrow.png')
        }
    }

    afterRender() {
        this.$projectName = this.find('.projectName');
        this.$customerName = this.find('.customerName');
        this.$tabs = [];
        this.$tabs[ProjectPanelTabs.DETAILS_TAB] = this.find('.details');
        this.$tabs[ProjectPanelTabs.ASSIGNED_USERS_TAB] = this.find('.assignedUsers');
        this.$tabs[ProjectPanelTabs.MANAGERS_TAB] = this.find('.managers');
        this.$tabs[ProjectPanelTabs.BUDGETS] = this.find('.budgets');

        this.nameInput = new NameInput({
            editable: true,
            placeholder: messageResource.getMessage('project.common.projectNamePlaceholder'),
            maxLength: EntityTextLimits.MAX_CPT_NAME,
            onChangeCb: (name) => {
                if (name !== this.state.projectName && name) {
                    this.nameInput.trigger('change', name)
                }
                this.nameInput.setState({
                    name,
                    invalid: !name,
                    focus: !name,
                })
            },
        }).init(this.$containerEl.find('.projectNamePlaceholder'))
        this.actions = new EditActionButton({
            panelEl: this.$panel,
            headerEl: this.$containerEl,
            needMove: true,
            needCopy: true,
            needDelete: true,
        }).init(this.find(".actions"))
        this.$assignedUsersCount = this.find('.assignedUsersCount');

        this.$assignedUsersTabTitle = this.find(".assignedUsers .tabText");
        this.$managersTabTitle = this.find(".managers .tabText");
    }

    updateView() {
        this.nameInput.setEditable(!this.state.readOnly)
        this.nameInput.resetName(this.state.projectName);
        this.actions.disableDeleteButton(
            this.disableDeleteButtonText(
                this.state.blockedDueToLockedTime,
                this.state.blockedDueToUnavailableToModifyTimeTrack,
                this.state.canManageAllUsersWithoutAutoApproved
            )
        );
        this.$customerName.text(this.state.customerName)
        this.actions.toggle(!this.state.readOnly)
    }

    disableDeleteButtonText(blockedDueToLockedTime, blockedDueToUnavailableToModifyTimeTrack, canManageAllUsersWithoutAutoApproved) {
        var disableText = null;
        if (blockedDueToLockedTime) {
            disableText = messageResource.getMessage("project.edit.cannot_delete_due_to_lock_time");
        }
        else if (blockedDueToUnavailableToModifyTimeTrack) {
            var projectText = messageResource.getMessage("common.project");
            disableText = messageResource.getMessage(canManageAllUsersWithoutAutoApproved ?
                                                     "hierarchy_entity.edit_popup.cannot_delete_due_to_unavailable_modify_time_of_autoapproved_users" :
                                                     "hierarchy_entity.edit_popup.cannot_delete_due_to_unavailable_modify_time",
                [projectText]);
        }
        return disableText;
    }

    onDependantDataUpdate(event) {
        if (event.type == 'assignmentsUpdated') {
            this.$assignedUsersCount.text(event['assignedUsersNumber']);
        }
    }
}




// WEBPACK FOOTER //
// ./web/js/panels/project/ProjectPanelHeader.js